// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__3CNhR"};